module.exports = __webpack_public_path__ + "static/img/pill_orange.4e4ef0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trackers/pill_orange.jpg
// module id = k3Fs
// module chunks = 0